import React from 'react';

import { useFormikContext } from 'formik';
import { useTranslation } from 'i18n/hooks';
import {
  FormControl,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'revibe-ui';
import { SpacedContainer } from 'revibe-ui';

import { useMediaQuery } from 'modules/common/hooks';
import { ITEM_FILTERS, ITEM_ORDER } from 'modules/item/utils/itemFilter';

import { SortIcon } from 'ui/icons/SortIcon';
import { MarketplaceAPI } from 'revibe-api';

export const SortFilter = () => {
  const { tu } = useTranslation('listing.filters.order');
  const { isMobile } = useMediaQuery();
  const { values, setFieldValue, handleSubmit } =
    useFormikContext<MarketplaceAPI.ItemFilters>();

  return (
    <div className="w-full">
      <FormControl label={tu('sorting', 'listing.filters')}>
        <Select
          value={values[ITEM_FILTERS.ORDER]}
          onValueChange={(selectedOption) => {
            setFieldValue(ITEM_FILTERS.ORDER, selectedOption || undefined);
            !isMobile && handleSubmit();
          }}
        >
          <SelectTrigger className="bg-gray-50 text-xs font-light uppercase">
            <SelectValue placeholder="Select a sorting option" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem
              className="text-xs font-light uppercase"
              value={ITEM_ORDER.MOST_RELEVANT}
            >
              <SpacedContainer
                type="horizontal"
                centered
                className="text-xs font-light uppercase"
              >
                <SortIcon className="h-5 w-5" />
                {tu(ITEM_ORDER.MOST_RELEVANT)}
              </SpacedContainer>
            </SelectItem>
            <SelectItem
              className="text-xs font-light uppercase"
              value={ITEM_ORDER.NEW}
            >
              <SpacedContainer
                type="horizontal"
                centered
                className="text-xs font-light uppercase"
              >
                <SortIcon className="h-5 w-5" />
                {tu(ITEM_ORDER.NEW)}
              </SpacedContainer>
            </SelectItem>
            <SelectItem
              className="text-xs font-light uppercase"
              value={ITEM_ORDER.HIGHEST_PRICE}
            >
              <SpacedContainer
                type="horizontal"
                centered
                className="text-xs font-light uppercase"
              >
                <SortIcon className="h-5 w-5" />
                {tu(ITEM_ORDER.HIGHEST_PRICE)}
              </SpacedContainer>
            </SelectItem>
            <SelectItem
              className="text-xs font-light uppercase"
              value={ITEM_ORDER.LOWEST_PRICE}
            >
              <SpacedContainer
                type="horizontal"
                centered
                className="text-xs font-light uppercase"
              >
                <SortIcon className="h-5 w-5" />
                {tu(ITEM_ORDER.LOWEST_PRICE)}
              </SpacedContainer>
            </SelectItem>
          </SelectContent>
        </Select>
      </FormControl>
    </div>
  );
};
